import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import GameListView from "./components/GameListView";
import addGameList from "./components/addGameList";
export default {
  name: "gameList",
  mixins: [loadMoreList, serchSelect],
  components: {
    addGameList: addGameList,
    GameListView: GameListView
  },
  data: function data() {
    return {
      pagingReqFn: "paymentGamesData",
      pagingReqValue: "",
      drawer: false
    };
  },
  activated: function activated() {
    this.getlangList();
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'paymentGamesDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    },
    openView: function openView(row) {
      this.$refs.GameListView.init(row);
    }
  }
};